import api from './api'

// Kullanıcı arayüz tercihleri (sunucuda) — sol menü favorileri gibi ELLE girilen
// tercihler yalnız localStorage'da durursa tarayıcı temizliğinde/başka cihazda kaybolur.
// Çağıranlar hata durumunda sessizce yerel kopyayla devam eder (tercih, akışı kırmamalı).
export const userPrefService = {
  getAll: async () => (await api.get('/me/prefs')).data,
  set: async (key, value) => (await api.put(`/me/prefs/${key}`, { value })).data,
}
